import styled, { CSSObject } from '@emotion/styled';
import type { SerializedStyles } from '@emotion/react';

export const Title = styled.div<{ active: boolean; customStyle: CSSObject | SerializedStyles }>`
	height: 100%;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	transition: color 0.25s ease;

	button,
	a {
		line-height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		color: ${({ active, theme }) => (active ? theme.colors.gray1 : theme.colors.gray3)};
		font-size: 16px;
		font-weight: bold;
		padding: 2px 8px;
		background: transparent;
		border: none;
		text-decoration: none;
		font-family: inherit;
		cursor: pointer;
		transition: all 0.25s ease;
		position: relative;
		overflow: visible;
		width: 100%;
		height: 100%;

		@media ${({ theme }) => theme.medias.desktop} {
			width: auto;
			height: auto;
			display: block;
		}
	}

	&:hover {
		button,
		a {
			color: ${({ theme }) => theme.colors.gray1};
		}
	}

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 0 13px;
		div {
			padding: 10px 5px;
		}
	}

	${({ customStyle }) => customStyle}
`;

export const TitleContent = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: left;
	overflow: hidden;
	background: transparent;
`;

export const Slider = styled.span`
	height: 4px;
	background-color: ${({ theme }) => theme.colors.primary1};
	position: absolute;
	bottom: 0;
	display: block;
	transition: all 0.25s ease;
	width: 50%;
	transform: translateX(-50%);
`;

export const MessageCounter = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background: ${({ theme }) => theme.colors.primary1};
	color: #fff;
	font-weight: 600;
	font-size: 8px;
	margin-left: 12px;
`;
